import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import { Flows } from "./flows";
import { Connectors } from "./connectors";

const tabsData = ["flows", "connectors"];

export const CredentialTabs = () => {
   const [currentTab, setCurrentTab] = useState("flows");

   const renderTab = () => {
      switch (currentTab) {
         case "flows":
            return <Flows />;
         case "connectors":
            return <Connectors />;
      }

      return <></>;
   };

   return (
      <SoftBox>
         <SoftBox>
            <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
            {renderTab()}
         </SoftBox>
      </SoftBox>
   );
};
